import { useQuery } from "@tanstack/react-query";
import { GINO_QUERY_KEYS } from "../queryKeys";
import { getChatList } from "../services/chat";

export const useGetChatList = () => {
  return useQuery({
    queryKey: GINO_QUERY_KEYS.CHAT_LIST,
    queryFn: getChatList,
    select: (chatList) => chatList.filter((chat) => chat.last_message && chat.last_message.text),
  });
};
